import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';import { useSearchParams } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ArrowBackIosNewSharpIcon from '@mui/icons-material/ArrowBackIosNewSharp';
import { visuallyHidden } from '@mui/utils';
import Divider from '@mui/material/Divider';
import { createNotification } from '../../../Config/NotificationToast';
import styled from '@emotion/styled';
import Select from "react-select";
import { FormGroup, Label, } from "reactstrap";
import { bypassOTP, deleteGuest, viewGuestUsers, } from '../../../redux/actions/UserManagementAction/GuestUserAction/GuestUserAction';
import { updateIsActiveStatus } from '../../../redux/actions/MasterDataAction/ProgramAction/programActions';
import * as routes from "../../../Router/RoutesURL";
import {
    stableSort,
    getComparator,
    rowOptions,
    options,
    getPermissionByAppName,
    validateDate,
} from '../../../utils/Helper'
import { useSelector, useDispatch } from 'react-redux';
import './GuestUser.scss';
import { CircularProgress, Switch } from '@mui/material';
import Delete from "../../../assets/images/CommonComponent/trash.svg";
import crossIcon from "../../../assets/images/CommonComponent/CrossIcon.svg";
import { Modal } from 'react-bootstrap';
import { guestType, tabKeys } from '../../../Config/Constant';
import moment from 'moment';
import { format, set } from 'date-fns';
import calendarIcon from '../../../assets/images/CommonComponent/calendarIcon.png';
import redCross from "../../../assets/images/CommonComponent/redCross.svg"
import greenCheck from "../../../assets/images/CommonComponent/GreenCheck.svg"
import CustomModal from '../../../components/CustomModal/CustomModal';
import DatePicker from '../../../components/DatePicker/DatePicker';

const MainHeading = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
}))


const headCells = [
    {
        id: 'first_name',
        disablePadding: true,
        label: 'FIRST NAME',
    },
    {
        id: 'last_name',
        disablePadding: false,
        label: 'LAST NAME',
    },
    {
        id: 'phone_number',
        disablePadding: false,
        label: 'MOBILE NO.',
    },
    {
        id: 'email_id',
        disablePadding: false,
        label: 'EMAIL ADDRESS',
    },
    {
        id: 'title',
        disablePadding: false,
        label: 'PROGRAM',
    },
    {
        id: 'check_in',
        disablePadding: false,
        label: 'START',
    },
    {
        id: 'check_out',
        disablePadding: false,
        label: 'END',
    },
    {
        id: 'is_active',
        disablePadding: false,
        label: 'STATUS',
    },
    {
        id: 'is_password_set',
        disablePadding: false,
        label: 'Password',
        disableSorting: true

    },
    {
        id: 'otp_required',
        disablePadding: false,
        label: 'OTP',
        disableSorting: true

    },
    {
        id: 'action',
        disablePadding: false,
        label: 'ACTION',
        disableSorting: true
    },
];

const EnhancedTableHead=(props)=> {
    const { order, orderBy, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align='left'
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                            hideSortIcon={headCell.disableSorting}
                            disabled={headCell.disableSorting}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar=(props)=> {
    const { numSelected, showLoader, setShowLoader, activeTab, searchParams, setSearchParams } = props;
    const [searchText, setSearchText] = useState(searchParams.get('filter_text') || '');
    const [maxDuration, setMaxDuration] = useState(searchParams.get('end_date') || '');
    const [minDuration, setMinDuration] = useState(searchParams.get('start_date') || '');
    const [programListing, setProgramListing] = useState([]);

    const [programID, setProgramID] = useState(searchParams.get('program') || '');
    const [selectedProgramTitle, setSelectedProgramTitle] = useState('');

    const programListingData = useSelector(state => state.viewGuestUsers?.viewGuestsList?.data?.program_data);


    useEffect(() => {
        const programIdFromParams = searchParams.get('program') || '';
        setProgramID(programIdFromParams);
        if (programListingData) {
            let data = programListingData.map((item) => {
                if(programID===item?.id?.toString())
                    setSelectedProgramTitle({
                        "label": item.title,
                        "value": item.title,
                        "key": programID
                    })

                return{
                ...item,
                value: item.title,
            }});
            data = [{
                "title": 'All',
                "value": 'All',
                "id": ''
            }, ...data]
            console.log(data);
            setProgramListing(data);
        } else {
            setProgramListing([]);
        }
    }, [programListingData]);

    useEffect(() => {
        if (activeTab == tabKeys.userManagement.GUEST_USER) {
            setSearchText(searchParams.get('filter_text') || '');
            setMinDuration(searchParams.get('start_date') || '');
            setMaxDuration(searchParams.get('end_date') || '');
            setProgramID(searchParams.get('program') || '');
        }
    }, [activeTab, searchParams]);

    const handleChangeSearch = (e) => {
        const newSearchText = e.target.value;
        setSearchText(newSearchText);
        const newParams = new URLSearchParams(searchParams);
        if (newSearchText) {
            newParams.set('filter_text', newSearchText);
        } else {
            newParams.delete('filter_text');
        }
        newParams.set('page_no', '1');
        setSearchParams(newParams, { replace: true });
    }

    const changeFromDate = (val) => {
        const formattedDate = val ? format(val, "yyyy-MM-dd") : '';
        setMinDuration(formattedDate);
        const newParams = new URLSearchParams(searchParams);
        if (formattedDate) {
            newParams.set('start_date', formattedDate);
        } else {
            newParams.delete('start_date');
            newParams.delete('end_date'); // Also clear end date
        }
        newParams.set('page_no', '1');
        setSearchParams(newParams, { replace: true });
    }

    const changeToDate = (val) => {
        const formattedDate = val ? format(val, "yyyy-MM-dd") : '';
        setMaxDuration(formattedDate);
        const newParams = new URLSearchParams(searchParams);
        if (formattedDate) {
            newParams.set('end_date', formattedDate);
        } else {
            newParams.delete('end_date');
        }
        newParams.set('page_no', '1');
        setSearchParams(newParams, { replace: true });
    }

    const handleChangeLevel = (e) => {
        const newProgramId = e.key;
        setSelectedProgramTitle({
            "label": e.label,
            "value": e.value,
            "key": e.key
        });
        const newParams = new URLSearchParams(searchParams);
        if (newProgramId) {
            newParams.set('program', newProgramId);
        } else {
            newParams.delete('program');
        }
        newParams.set('page_no', '1');
        setSearchParams(newParams, { replace: true });
    }



    return (

        <div>
            <Toolbar sx={{
                pl: { sm: 2 },
                pt: { sm: 2 },
                pb: { sm: 2 },
                pr: { xs: 1, sm: 1 }
            }}
            >
                <div className='d-flex justify-content-between align-items-center w-100'>
                    <div>
                        <MainHeading
                            sx={{ flex: '1 1 100%', }}
                            variant="h6"
                            id="tableTitle"
                            component="div"
                        >
                            Guest List
                        </MainHeading>
                    </div>
                    <div className='GuestUserLevelDiv'>
                        <FormGroup className="FormGroup has-float-label class-menu-dropdown ">
                            <Label>Program:</Label>
                            <Select
                                className="react-select"
                                classNamePrefix="react-select"
                                value={selectedProgramTitle}
                                options={programListing?.map((guest) => {
                                    return {

                                        label: guest.title,
                                        value: guest.title,
                                        key: guest.id
                                    };
                                })}
                                onChange={handleChangeLevel}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary25: '#F5F5F5',
                                        primary: '#74613C',
                                    },
                                })}
                            />

                        </FormGroup>
                        <div className='DurationDiv d-flex align-items-center'>
                            <Label>Date:</Label>
                            <DatePicker
                                onChange={date => { changeFromDate(date) }}
                                showMonthDropdown={true}
                                showYearDropdown={true}
                                value={validateDate(minDuration) ? new Date(moment(minDuration, "YYYY-MM-DD").format('MM-DD-YYYY')) : ''}
                                maxDate={new Date()}
                                popperPlacement={"bottom"}
                                width={'140px'}
                                height={'48px'}
                                isClearable={minDuration}
                                placeholder={'Start'}
                            />
                            
                            <div className='mx-2'>to</div>
                            <DatePicker
                                onChange={date => { changeToDate(date) }}
                                showMonthDropdown={true}
                                showYearDropdown={true}
                                value={validateDate(maxDuration) ? new Date(moment(maxDuration, "YYYY-MM-DD").format('MM-DD-YYYY')) : ''}
                                minDate={minDuration ? new Date((moment(minDuration, "YYYY-MM-DD").add(1, 'days')).format('MM-DD-YYYY')) : null}
                                popperPlacement={"bottom"}
                                width={'140px'}
                                height={'48px'}
                                disabled={!minDuration}
                                isClearable={maxDuration}
                                placeholder={'End'}
                            />
                        </div>
                        <div className="separator"></div>

                        <div className="mr-sm-2 searchDiv class-search ">
                            <input
                                value={searchText}
                                className="form-control mr-sm-2 class-search"
                                type="search"
                                placeholder=" Search Keyword"
                                aria-label="Search"
                                onChange={handleChangeSearch}
                            ></input>
                        </div>
                    </div>
                </div>
            </Toolbar>
            <Divider />
        </div>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const GuestUserTable = (props) => {
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [viewGuestListMainData, setViewGuestListMainData] = useState('');
    const [searchParams, setSearchParams] = useSearchParams()
    const [showLoader, setShowLoader] = useState(false);
    const navigate = useNavigate()
    const {loading} = useSelector(state => state.viewGuestUsers);
    const viewGuestListDat = useSelector(state => state.viewGuestUsers);
    const viewGuestListDataRes = useSelector(state => state.viewGuestUsers.viewGuestsList);
    const dispatch = useDispatch();
    const { permission, activeTab } = props;
    const [showConfirm, setShowConfirm] = useState(false);
    const [id, setId] = useState('');

    useEffect(() => {
        if (activeTab == tabKeys.userManagement.GUEST_USER) {
            setShowLoader(true);
            let sendRequest = {
                "page_no": searchParams.get('page_no') || 1,
                "page_size": searchParams.get('page_size') || 10,
                'filter_text': searchParams.get('filter_text') || '',
                "start_date": searchParams.get('start_date') || '',
                "end_date": searchParams.get('end_date') || '',
                "program": searchParams.get('program') || '',
                "role_id": 1,
                "type": guestType.ENROLLED
            };
            dispatch(viewGuestUsers(sendRequest));
        }else{
            setOrder('');
            setOrderBy('');
            setRowsPerPage(10)
        }
    }, [activeTab, searchParams, dispatch]);

    useEffect(()=>{
        if(loading && !viewGuestListDataRes?.data?.guest_users && !viewGuestListDat.error){
            setShowLoader(true)
        }else if(!loading)
            setShowLoader(false)

    }, [loading])

    useEffect(() => {
        if (viewGuestListDat.error !== "No data available to show for guests users") {
            setViewGuestListMainData(viewGuestListDataRes && viewGuestListDataRes?.data?.guest_users);
        } else {
            setViewGuestListMainData("");
        }
    }, [viewGuestListDataRes, viewGuestListDat])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === "asc";
        const newOrder = isAsc ? "desc" : "asc";
        setOrder(newOrder);
        setOrderBy(property);
        const newParams = new URLSearchParams(searchParams);
        newParams.set('order_by', property);
        newParams.set('order_by_type', newOrder);
        newParams.set('page_no', '1');
        setSearchParams(newParams, { replace: true });
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = viewGuestListDataRes && viewGuestListDataRes.map((n) => n.name);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const handleChangePageNext = (newPage) => {
        const nextPage = (viewGuestListDataRes?.data?.current_page_no || 1) + 1;
        setPage(nextPage);
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page_no', nextPage.toString());
        setSearchParams(newParams, { replace: true });
    };
    const handleChangePagePrev = (newPage) => {
        const prevPage = (viewGuestListDataRes?.data?.current_page_no || 2) - 1;
        setPage(prevPage);
        const newParams = new URLSearchParams(searchParams);
        if (prevPage > 1) {
            newParams.set('page_no', prevPage.toString());
        } else {
            newParams.delete('page_no');
        }
        setSearchParams(newParams, { replace: true });
    };

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(1);
        const newParams = new URLSearchParams(searchParams);
        if (newRowsPerPage !== 10) {
            newParams.set('page_size', newRowsPerPage.toString());
        } else {
            newParams.delete('page_size');
        }
        newParams.delete('page_no');
        setSearchParams(newParams, { replace: true });
    };


    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - viewGuestListDataRes && viewGuestListDataRes?.length) : 0;


    const handleChangeViewPro = (selectedUserId, userStatus) => {
        if (userStatus === 1) {
            navigate(routes.VIEW_USER, { state: { selectedUserId, userStatus, permission } })
        }
    };


    const handleChangeOption = (e, id) => {
        if (permission === "write") {
            if (e.value === "Active") {
                viewGuestListMainData.find(v => v.id === id).is_active = 1;
            } else {
                viewGuestListMainData.find(v => v.id === id).is_active = 0;
            }
            setViewGuestListMainData(viewGuestListMainData)
            const sendRequest = {
                "feature_type": "guest",
                "id": id,
                "status": e.value === "Active" ? 1 : 0
            };
            dispatch(updateIsActiveStatus(sendRequest));
        } else {
            createNotification('warning', "Access Restricted");
        }
    }

    const handleChangeEditUser = (selectedUserId, userStatus) => {
        if (permission === "write") {
            if (userStatus === 1) {
                navigate(routes.EDIT_USER, { state: { selectedUserId } });
            }
        } else {
            createNotification('warning', "Access Restricted");
        }
    };


    const handleDelete = (id) => {
        if (permission === "write") {
            setId(id)
            setShowConfirm(true);
        } else {
            createNotification('warning', "Access Restricted");
        }
    };

    const handleDeleteGuest = () => {
        const sendRequestDelete = {
            id,
            onSuccessCallback: ()=>{
                if(viewGuestListDataRes && viewGuestListDataRes?.data?.start === viewGuestListDataRes?.data?.end){
                    const newParams = new URLSearchParams(searchParams);
                    newParams.set("page_no", (viewGuestListDataRes?.data?.current_page_no - 1 || 1));
                    setSearchParams(newParams, { replace: true });
                }else{
                    
                    const sendRequest = {                        
                        "page_no": viewGuestListDataRes?.data?.current_page_no || 1,
                        "page_size": searchParams.get('page_size') || 10,
                        'filter_text': searchParams.get('filter_text') || '',
                        "start_date": searchParams.get('start_date') || '',
                        "end_date": searchParams.get('end_date') || '',
                        "program": searchParams.get('program') || '',
                        "role_id": 1,
                        "type": guestType.ENROLLED

                    };
                    dispatch(viewGuestUsers(sendRequest));
                }
                setShowConfirm(false);
            }
        };
        dispatch(deleteGuest(sendRequestDelete));
    }

    const cancelWarnModal = () => {
        setShowConfirm(false);
    }


    return (
        <>
            <Box sx={{ width: '100%' }} className="GuestUserBox h-100">
              <Paper className='d-flex flex-column' sx={{ width: '100%', mb: 1, borderRadius: 2, height: 'calc(100% - 57px)' }}>
                    <EnhancedTableToolbar numSelected={selected.length} pageNos={page}
                        activeTab={activeTab} 
                        searchParams={searchParams}
                        setSearchParams={setSearchParams}
                        showLoader={showLoader}
                        setShowLoader={setShowLoader}
                        rowsPerPageNos={rowsPerPage} />
                    {
                        showLoader ?
                        <div className='w-100 py-5 text-center'>
                            <CircularProgress sx={{'color': '#74613C'}}/>
                        </div>
                        :
                            viewGuestListMainData?.length > 0  ? <TableContainer sx={{ pt: 0, pr: 3, pb: 0, pl: 3, height: '100%' }}>
                            <Table
                                sx={{ minWidth: 750 }}
                                aria-labelledby="tableTitle"
                                size='small'
                                stickyHeader
                            >
                                <EnhancedTableHead
                                    numSelected={selected.length}
                                    order={order}
                                    orderBy={orderBy}
                                    onSelectAllClick={handleSelectAllClick}
                                    onRequestSort={handleRequestSort}
                                    rowCount={viewGuestListDataRes && viewGuestListDataRes?.length || 0}
                                />
                                <TableBody>
                                    {
                                        stableSort(viewGuestListMainData, getComparator(order, orderBy))
                                            .map((row, index) => {
    
                                                const labelId = `enhanced-table-checkbox-${index}`;

                                                return (
                                                    <TableRow hover onClick={(event) => handleClick(event, row.firstName)} role="checkbox"
    
                                                        tabIndex={-1}
                                                        key={index}
    
                                                    >
                                                        <TableCell component="th" id={labelId} scope="row" padding="none" sx={{ color: row.is_active == 1 ? '#000000' : "#AAAAAA" }}>{row.first_name}</TableCell>
                                                        <TableCell align="left" sx={{ color: row.is_active == 1 ? '#000000' : "#AAAAAA" }}>{row.last_name}</TableCell>
                                                        <TableCell align="left" sx={{ color: row.is_active == 1 ? '#000000' : "#AAAAAA" }}>{row.phone_number}</TableCell>
                                                        <TableCell align="left" sx={{ color: row.is_active == 1 ? '#000000' : "#AAAAAA" , textTransform: "lowercase"}}>{row.email_id}</TableCell>
                                                        <TableCell align="left" sx={{ color: row.is_active == 1 ? '#000000' : "#AAAAAA" }}>{row.title}</TableCell>
                                                        <TableCell align="left" sx={{ color: row.is_active == 1 ? '#000000' : "#AAAAAA" }}>{row.check_in}</TableCell>
                                                        <TableCell align="left" sx={{ color: row.is_active == 1 ? '#000000' : "#AAAAAA" }}>{row.check_out}</TableCell>
                                                        <TableCell align="left" sx={{ color: row.is_active == 1 ? '#000000' : "#AAAAAA" }}
    
                                                        >
                                                            <Select
    
                                                                className="react-select status-select"
                                                                classNamePrefix="react-select"
                                                                onChange={(e) => { handleChangeOption(e, row.id) }}
                                                                value={row.is_active === 1 ? { label: "Active", value: "Active" } : { label: "Inactive", value: "Inactive" }}
                                                                options={options}
                                                                isSearchable={false}
                                                                menuPlacement="auto"
                                                                menuPosition="absolute"   
                                                                menuPortalTarget={null}
                                                                theme={(theme) => ({
                                                                    ...theme,
                                                                    isFocused: "#74613C",
                                                                    colors: {
                                                                        ...theme.colors,
                                                                        primary25: '#F5F5F5',
                                                                        primary: '#f6f4f0',
                                                                    },
                                                                })}
                                                                getOptionLabel={(row) => (
                                                                    <><span className={row.label === "Active" ? "ActiveClass" : "InactiveClass"}>
                                                                        {row.label}
                                                                    </span>
                                                                        {row.status === 1 && (
                                                                            <div
    
                                                                            ></div>
                                                                        )}
                                                                    </>
                                                                )}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ color: row.status !== 'rejected'? '#000000' : "#AAAAAA" }}>
                                                            {   
                                                                !row.is_password_set ?
                                                                <img className="mainIcon mr-2 " src={redCross} alt="" width="16px" height="16px" />
                                                                :
                                                                <img className="mainIcon mr-2 " src={greenCheck} alt="" width="22px" height="22px" />
                                                            }
                                                        </TableCell>
                                                        <TableCell align="left" sx={{ color: row.status !== 'rejected'? '#000000' : "#AAAAAA" }}>
                                                            <CustomSwitch key={index} row={row} permission={permission} setViewGuestListMainData={setViewGuestListMainData} />
                                                        </TableCell>
                                                        <TableCell align="left" className='View'> <ul className="list-group d-flex flex-row">
                                                            <li className={row.is_active == 1 ? 'list-group-item ViewEditClick p-0 ' : "list-group-item ViewEditNotClick p-0"}
                                                                onClick={() => { handleChangeViewPro(row.id, row.is_active) }}><i className="fas fa-eye mr-1"></i> View</li>
                                                            {
                                                                getPermissionByAppName("Guest User Management") === "write" &&
                                                                <>
                                                                    <li className={row.is_active == 1 ? 'list-group-item ViewEditClick p-0 ' : "list-group-item ViewEditNotClick p-0"}
                                                                        onClick={() => { handleChangeEditUser(row.id, row.is_active) }}><i className="fa fa-pen mr-1"></i> Edit</li>
                                                                    <li className="list-group-item Delete p-0" onClick={() => { handleDelete(row.id) }}><img src={Delete} className="mr-1 mb-1" alt="Avatar" width="14px" height="16px" /> Delete</li>
                                                                </>
                                                            }
    
                                                        </ul></TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                    {emptyRows > 0 && (
                                        <TableRow
    
                                        >
                                            <TableCell colSpan={6} />
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                      : <div className='text-center w-100 text-muted mt-3'>No Records</div>
                    }
                </Paper>
                {
                    viewGuestListMainData
                    &&
                    <div className='paginationBlock'>
                        <div className='textData'><p>Items per page: </p></div>
                        <FormGroup className="FormGroup has-float-label rowsSelect class-menu-dropdown ">
                            <Select
                                placeholder={rowsPerPage}
                                className="react-select"
                                classNamePrefix="react-select"
                                value={rowsPerPage}
                                options={rowOptions}
                                isSearchable={false}
                                onChange={handleChangeRowsPerPage}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary25: '#F5F5F5',
                                        primary: '#74613C',
                                    },
                                })}
                                menuPlacement="top"
                                menuPosition="fixed"
                                styles={{
                                    menu: (base) => ({
                                        ...base,
                                        top: 'auto',
                                        bottom: 0,
                                    }),
                                }}
                            />
                        </FormGroup>
                        {viewGuestListDataRes?.data && <p className='endText'>   {viewGuestListDataRes?.data?.start} - {viewGuestListDataRes?.data?.end} of {viewGuestListDataRes?.data?.total}</p>}
                        <p>
                            
                            <button className={`btnPrev ${viewGuestListDataRes?.data?.current_page_no === 1 ? "opacityBtns" : ''}`} disabled={viewGuestListDataRes?.data?.current_page_no === 1} onClick={() => { handleChangePagePrev() }}>
                                <ArrowBackIosNewSharpIcon className='iconBtn' />
                            </button> 
                            <button className={`btnPrev ${viewGuestListDataRes?.data?.current_page_no === viewGuestListDataRes?.data?.total_pages ? "opacityBtns" : ''}`} disabled={viewGuestListDataRes?.data?.current_page_no === viewGuestListDataRes?.data?.total_pages} onClick={() => { handleChangePageNext() }}>
                                <ArrowForwardIosSharpIcon className='iconBtn' />
                            </button></p>
                    </div>
                }
            </Box>
        
            <Modal centered className="guestUser-modal-warning br-8" show={showConfirm} onHide={() => { setShowConfirm(false) }}>
                <Modal.Header>
                    <div className="modalText-guest pb-4">Are you sure you want to delete this guest account ?</div>
                </Modal.Header>
                <Modal.Body>
                    <div className="">
                        <label htmlFor="exampleFormControlInput1" className="form-label DeleteDesc-guest">
                        This will remove guest's online access to all your wellness programme details, sessions, consultant recommendations and other data.
                        </label>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-success greenButton mr-3" onClick={cancelWarnModal}>
                        Cancel</button>
                    <button type="button" className="btn btn-danger redButton " onClick={handleDeleteGuest}>
                        Delete</button>
                </Modal.Footer>
            </Modal>
        </>
        );
}
export default GuestUserTable;

const CustomSwitch = ({row, permission, setViewGuestListMainData})=>{
    const [show, setShow] = useState(false);
    const dispatch = useDispatch();

    

    const handleToggleButton = () => {
        let val =  row.is_otp_varified ? 0 : 1;
        console.log(val)
        const sendRequest = {
            "status": val,
            "id": row.id,
        };
        setViewGuestListMainData(prev=>{
            let newData = [...prev];
            for(let i=0; i<prev.length; i++){
                if(newData[i].id==row.id)
                    newData[i].is_otp_varified = val
            }

            return newData
        })
        dispatch(bypassOTP(sendRequest));
        setShow(false)
    }


    return (
        <>
            <Switch  
                disabled={permission !== "write"}
                inputProps={{ 'aria-label': 'Color switch demo' }} 
                checked={!row.is_otp_varified}  onChange={(e) => { row.is_otp_varified ? handleToggleButton() : setShow(true)}} />
            <CustomModal
                show={show}
                setShow={setShow}
                content={row.is_password_set ? 'Are you sure, you want to bypass verification for forgot password?' : 'Are you sure, you want to bypass verification for authentication?'}
                onClickNo={()=>setShow(false)}
                onClickYes={handleToggleButton}
            />
        </>
    )
}